<template>
    <a-modal
            title="请输入检查结果"
            okText="确认"
            cancelText="取消"
            width="1300px"
            :visible="visible"
            :confirm-loading="confirmLoading"
            @ok="handleOk"
            @cancel="handleCancel"
    >
        <index3-dialog @change="changeName"></index3-dialog>
    </a-modal>
</template>

<script>
import index3Dialog from './index3Dialog'
    export default {
        name: "FormModel",
        components:{index3Dialog},
        props:{
            visible:{
                type:Boolean,
                default:false
            },
            param:{
                type:Object,
                default: ()=>{
                    return {}
                }
            }
        },
        data() {
            return {
                confirmLoading: false,
                name:''
            };
        },
        created(){
            this.initForm();
        },
        methods: {
            initForm(){
            },
            handleOk(e) {
                if (this.name) {
                    //TODO: 返回值
                    this.$emit("update:visible",false)
                    this.$emit("dialogBack",{name:this.name,link:this.link});
                } else {
                    // alert(this.name)
                }
            },
            handleCancel(e) {
                this.$emit("update:visible",false)
            },
            changeName(e)
            {
                this.name=e.name;
                this.link=e.link;
            }
        },
    }
</script>

<style scoped lang="scss">

    /*/deep/ .ant-modal-body{*/
    /*height: 70vh;*/
    /*overflow-y: scroll;*/
    /*}*/

</style>